import { useCallback } from 'react';

import { DropdownItem } from '@treezor/design-system';

import { useTranslation } from 'react-i18next';

import { openModal } from '@/store/actions/core.actions';

import { useAccesControl } from '@/hooks/useAccessControl';
import { useAppDispatch } from '@/hooks/redux-helpers';

import { useProfileContext } from '@/features/context/ProfileContext';
import { featuresSlugs } from '@/features/roles/store/models/features.model';
import { useMatomo } from '@/features/matomo/useMatomo';

import { IPayoutModalProps } from './PayoutModal';

interface IPayoutProps {
  onClick?: () => void;
}

export const PayoutAction = ({ onClick }: IPayoutProps) => {
  const { t } = useTranslation();

  const { user } = useProfileContext();
  const dispatch = useAppDispatch();
  const { hasAccessToFeature } = useAccesControl();
  const { triggerEvent } = useMatomo();

  const payoutProcessToggle = useCallback(() => {
    if (user?.userId) {
      triggerEvent('payout', { 'payout-action': 'start' });
      dispatch(openModal<IPayoutModalProps>('payoutModal', { user }, { maxWidth: 'lg' }));
    }
    if (onClick) {
      onClick();
    }
  }, [dispatch, user, triggerEvent, onClick]);

  if (!hasAccessToFeature(featuresSlugs.PAYOUT)) {
    return null;
  }

  return (
    <DropdownItem
      testId="create-payout"
      onClick={payoutProcessToggle}
      label={t('pages.currentProfiles.wallets.actions.createPayout')}
    />
  );
};
